import { render, staticRenderFns } from "./scan.vue?vue&type=template&id=1aa7445c&scoped=true&"
import script from "./scan.vue?vue&type=script&lang=js&"
export * from "./scan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7445c",
  null
  
)

export default component.exports